"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _vuex = require("vuex");
var _formatMixin = require("@/utils/formatMixin");
var _encrypt = require("@/utils/encrypt");
var _user = require("@/api/user");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      config: {},
      depositDialog: false,
      setdepositDialog: false,
      moneyList: {
        count: 0
      },
      // 划扣流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      lastExecutedTime: 0,
      // 上次执行的时间
      user_money: 0,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      bank_no: '',
      pk: 0,
      money: 0,
      get_money: 0,
      jd_withdrawal_rate: ''
      // alipay_name:'',
      // alipay_login:''
    };
  },
  created: function created() {
    // if(this.checkIsMobile() && this.isAdmin){
    //   this.$router.push({ name: 'JdwithdrawalPhone' });
    // }
    this.getMoneyList();
    this.getConfigList();
    this.chheckAipay();
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    lines: function lines() {
      return this.config.value.split(/[；;]/).map(function (i) {
        return i.trim();
      }).filter(Boolean);
    },
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    },
    is_withdrawal: function is_withdrawal() {
      return this.perms.includes('withdrawal_ok');
    }
  }),
  methods: {
    getConfigList: function getConfigList() {
      var _this = this;
      (0, _user.getConfigList)({
        group: 'without',
        ttype: 'jd'
      }).then(function (response) {
        if (response.data) {
          _this.config = response.data[0];
        }
      });
    },
    clossPop5: function clossPop5() {
      var _this2 = this;
      (0, _user.updateConfig)(this.config.id, this.config).then(function (res) {
        _this2.getConfigList();
        _this2.setdepositDialog = false;
        _this2.$message({
          message: "编辑成功",
          type: "success"
        });
      });
    },
    checkIsMobile: function checkIsMobile() {
      var userAgent = navigator.userAgent.toLowerCase();
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    },
    chheckAipay: function chheckAipay() {
      var _this3 = this;
      (0, _request.default)({
        url: "/system/user/checkUserAlipay/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          // this.alipay_name = response.data.alipay_name
          // this.alipay_login = response.data.alipay_login
          _this3.jd_withdrawal_rate = response.data.jd_withdrawal_rate;
        }
        _this3.listLoading = false;
      });
    },
    // 获取提现明细——done
    getMoneyList: function getMoneyList() {
      var _this4 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/order/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          type: 2,
          remark: 'JD余额提现',
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          is_pay: -1
        }
      }).then(function (response) {
        if (response.data) {
          _this4.moneyList = response.data.data;
          _this4.user_money = response.data.data.jd_money;
        }
        _this4.listLoading = false;
      });
    },
    // 确认打款，加限制——done
    withMoney: function withMoney(value) {
      var _this5 = this;
      this.$confirm('确认提现金额' + value.money + '元到平台余额?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/JdwithMoney/",
          method: 'put',
          data: {
            record_id: value.pk
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this5.$message({
              message: '提现成功',
              type: 'success'
            });
            _this5.getMoneyList(); // 刷新列表
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消提现'
        });
      });
    },
    withMoneyOnly: function withMoneyOnly(value) {
      var _this6 = this;
      this.$confirm('确认线下已完成提现金额' + value.money + '元', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/JdwithMoneyOnly/",
          method: 'put',
          data: {
            record_id: value.pk
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this6.$message({
              message: '提现成功',
              type: 'success'
            });
            _this6.getMoneyList(); // 刷新列表
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消提现'
        });
      });
    },
    clossPop3: function clossPop3() {
      var _this7 = this;
      var rate_money = this.get_money * this.jd_withdrawal_rate / 100;
      // console.log(rate_money)
      if (rate_money > 0) {
        this.$confirm('需收取' + this.jd_withdrawal_rate + '%的提现服务费用' + rate_money + '元（平台余额扣除）', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          // console.log('发起提现')
          (0, _request.default)({
            url: "/system/user/JdWithdrawalApplication/",
            method: 'put',
            data: {
              money: _this7.get_money,
              bank_no: _this7.bank_no,
              shop_id: _this7.$user.data.shop
            }
          }).then(function (response) {
            if (response.code == 200) {
              _this7.getMoneyList(); // 刷新列表
              _this7.dialogFormVisible3 = false;
              _this7.lastExecutedTime = currentTime;
            }
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function () {
          _this7.$message({
            type: 'info',
            message: '已取消提现'
          });
        });
      } else {
        (0, _request.default)({
          url: "/system/user/JdWithdrawalApplication/",
          method: 'put',
          data: {
            money: this.get_money,
            bank_no: this.bank_no,
            shop_id: this.$user.data.shop
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this7.getMoneyList(); // 刷新列表
            _this7.dialogFormVisible3 = false;
            _this7.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }

      // request({
      //     url: `/system/user/JdWithdrawalApplication/`,
      //     method: 'put',
      //     data: {
      //       money:this.get_money,
      //       bank_no:this.bank_no,
      //       shop_id: this.$user.data.shop
      //     }
      // }).then(response => {
      //     if (response.code == 200) {
      //         this.getMoneyList() // 刷新列表
      //         this.dialogFormVisible3 = false
      //         this.lastExecutedTime = currentTime
      //     }
      // }).catch(error => {
      //     console.log(error)
      // })
    },
    deleteRow: function deleteRow(value) {
      this.$message({
        type: 'info',
        message: '暂时关闭此功能'
      });
      // this.$confirm('确认删除当前提现记录?', '警告', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(() => {
      //     // 发请求提交数据给后端
      //     request({
      //         url: `/system/order/JduserRecordDel/`,
      //         method: 'delete',
      //         data: {
      //             record_id: value.pk
      //         }
      //     }).then(response => {
      //         if (response.code == 200) {
      //             this.$message({
      //                 message: '删除成功',
      //                 type: 'success'
      //             })

      //             this.getMoneyList() // 刷新列表
      //         }
      //     }).catch(error => {
      //         console.log(error)
      //     })

      // }).catch(() => {
      //     this.$message({
      //         type: 'info',
      //         message: '已取消删除'
      //     });
      // });
    },
    addMoney: function addMoney() {
      this.dialogFormVisible2 = true;
    },
    getMoney: function getMoney() {
      //申请提现
      this.dialogFormVisible3 = true;
    }
  }
};